function CopyRight() {
  return (
    <div className="copyRightSection d-flex align-items-center justify-content-center gap-sm-3 gap-2 flex-md-row flex-column">
      <p>
        Copyright &copy; {new Date().getFullYear()} by Boll-e&trade;. All Rights
        Reserved
      </p>
      <span className="d-sm-flex d-none"></span>
      <p>
        <a
          href="/terms-and-conditions"
          target="_blank"
          style={{ textDecoration: "none", color: "white" }}
        >
          Terms & Conditions
        </a>
      </p>
    </div>
  );
}

export default CopyRight;
